import { Stack } from '@mui/material'
import { useLoanCalendarSimulation } from '../LoanCalendarSimulationProvider'
import LoanCreditReportCard from './LoanCreditReportCard'
import LoanLastTransactionCard from './LoanLastTransactionCard'
import LoanLateStatusCard from './LoanLateStatusCard'
import LoanNextPaymentCard from './LoanNextPaymentCard'
import LoanStatusCard from './LoanStatusCard'

const LoanCalendarStatusCards = () => {
  const { currentSimulation } = useLoanCalendarSimulation()
  const simulation = currentSimulation.simulation

  return (
    <Stack spacing={2}>
      <LoanStatusCard simulation={simulation} />
      <LoanLateStatusCard simulation={simulation} />
      <LoanCreditReportCard signedSimulation={currentSimulation} />
      <LoanNextPaymentCard threeNextPayments={simulation.getThreeNextPlannedPayments()} />
      <LoanLastTransactionCard summaryInformation={simulation.summaryInformation} />
    </Stack>
  )
}

export default LoanCalendarStatusCards
